import { StatusPerkRewardType, StatusPerkType } from '../state';

export const statusPerkRewardTypeMap: Record<
  StatusPerkType,
  StatusPerkRewardType
> = {
  DailyWheel: 'Coins',
  ShopWeeklyPromotion: 'Percentage',
  AccessToBetterRaf: 'Multiplier',
  StatusExclusiveGames: 'Availability',
  Cashback: 'Percentage',
  PriorityCustomerSupport: 'Availability',
  MultiplierOnLevelUp: 'Multiplier',
  GemStones: 'Hidden',
  VipHost: 'Availability',
};
